import { FunctionComponent, useEffect, useState } from 'react';
import { Typography, Input, Snackbar, Select, SelectMultiple } from '../../tailwindcomponents';
import { MenuBook, FormatListNumbered, Description, Title } from '../../components/icons';
import { Request, ATAChapter, RatingEnum } from '../../types/capabilityList';
import CapabilityListApi from '../../api/capabilityList';
interface ShopOptions {
    name: string,
    id: number
}

interface TextFieldsProps {
    request: Request,
    viewMode: boolean,
    setRequest: Function,
    ATAChapters: ATAChapter[],
    resetShops: boolean,
    setResetShops: Function,
}

const shopOptions: ShopOptions[] = [{ name: 'Select/Unselect All', id: 0 }, { name: 'AVIONICS', id: 1 }, { name: 'COMPONENT', id: 2 }, { name: "COMPOSITE", id: 3 }, { name: 'ENGINE', id: 4 }, { name: 'INTERIOR', id: 5 }, { name: 'METAL', id: 6 }];

const ratingOptions = [
    { name: "A Rating", id: 1 },
    { name: "B Rating", id: 2 },
    { name: "C Rating", id: 3 }
  ];

const TextFields: FunctionComponent<TextFieldsProps> = ({ request, setRequest, viewMode, ATAChapters, resetShops, setResetShops}) => {

    const [toggleSelectAreas, setToggleSelectAreas] = useState<boolean>(false);
    const [selectedShops, setSelectedShops] = useState<number[]>([]);
    const [selectedRating, setSelectedRating] = useState<number>(0);
    const [classTypeOptions, setClassTypeOptions] = useState<string[]>([]);
    const [snackbarMessage, setSnackbarMessage] = useState<string>("");

    useEffect(() => {
        if (resetShops) {
            setResetShops(false);
            setInitialShopState(request);
            setSelectedRating(0)
        }
        else {
            setInitialShopState(request);
            setSelectedRating(request.rating)
        }

        CapabilityListApi.GetAllAtaChaptersRatings().then(res => {
            const uniqueRatings = new Set(res.data.map((obj: ATAChapter) => obj.rating));
            setClassTypeOptions(Array.from(uniqueRatings));
        });

    }, [request.request_id, request.version_nr, resetShops]);

    const onUpdateTextFields = (field: keyof Request, value: string) => {
        setRequest((prevState: Request) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const toggleSelectAllAreas = (event: number[]) => {
        if (event.includes(0)) {
            setSelectedShops([1, 2, 3, 4, 5, 6]);
            setToggleSelectAreas(!toggleSelectAreas);
        }
        if (event.includes(0) && toggleSelectAreas === true) {
            setToggleSelectAreas(!toggleSelectAreas);
            setSelectedShops([]);
        }
    }
    const setInitialShopState = (data: Request) => {
        const selectedShops: number[] = [];
        data.shops.forEach(shop => {
            const index = shopOptions.findIndex(s => s.name === shop.shop_name);
            if (index > -1) {
                selectedShops.push(index);
            }
        }
        );
        setSelectedShops(selectedShops);
    }
    const onSelectedShop = (e: number[]) => {
        setSelectedShops(e);
        toggleSelectAllAreas(e);
        const selectedShopNames: { shop_name: string }[] = [];
        e.forEach(index => {
            const shopOption = shopOptions[index];
            if (shopOption) {
                selectedShopNames.push({ shop_name: shopOption.name });
            }
        });
        setRequest((prevState: Request) => ({ ...prevState, shops: selectedShopNames }));
    }

    const onSelectedRating = (e: number) => {
        const previousRating = request.rating;

        if ( request.request_id !== null && request.request_id !== undefined &&  // Apply rules only when editing
            (
                (previousRating === RatingEnum.A && e === RatingEnum.B) ||
                (previousRating === RatingEnum.B && e === RatingEnum.A) ||
                (previousRating === RatingEnum.B && e === RatingEnum.C) ||
                (previousRating === RatingEnum.C && e === RatingEnum.B)
            )
        ) {
            setSnackbarMessage("It’s not possible to switch ratings between A and B or B and C");
            return;
        }
    
        setSelectedRating(e);
        
        if(e === RatingEnum.A)
        {
            setSelectedShops([]);
            setRequest((prevState: Request) => ({ ...prevState, rating: e, shops: [], component_name: '', other_text: '', class_type: '' }));
        }
        else if(e === RatingEnum.B)
        {
            setSelectedShops([shopOptions.findIndex(s => s.name === 'ENGINE')]);

            const bRating = classTypeOptions.find(option => option.toLowerCase().includes('b-rating')) || '';

            setRequest((prevState: Request) => ({ ...prevState, rating: e, shops: [{ shop_name: 'ENGINE' }], part_number: '', part_name: '', dash_numbers: '', description: '', class_type: bRating }));
            
        }
        else
        {
            setRequest((prevState: Request) => ({ ...prevState, rating: e, component_name: '', other_text: '', class_type: '' }));
        }
      };

    function onAtaChapterSelected(e: string | undefined) {

        const selectedAtaChapter = ATAChapters.find(s => s.ata_chapter === e);

        if(selectedRating === RatingEnum.B)
        {
            const bRating = classTypeOptions.find(option => option.toLowerCase().includes('b-rating')) || '';
            
            setRequest((prevState: Request) => ({ ...prevState, ata_chapters: e, class_type: bRating }));
        
        }
        else
        {
            setRequest((prevState: Request) => ({ ...prevState, ata_chapters: e, class_type: selectedAtaChapter!.rating }));
        }
    }

    function onClassTypeChanged(e: string) {
        
        if(selectedRating !== RatingEnum.B)
        {
            const bRating = classTypeOptions.find(option => option.toLowerCase().includes('b-rating')) || '';

            setRequest((prevState: Request) => ({ ...prevState, class_type: bRating}));
        }
        setRequest((prevState: Request) => ({ ...prevState, class_type: e}));
    }


    return (
        <>
        <div className="flex flex-wrap justify-center" >
            <Typography color='primary' variant='h1' text={request.part_number} align='center' />
        </div>
        <div className="flex flex-wrap justify-center"  >
            <div className="w-full sm:w-full md:w-5/12">
                <Input icon={<Description />} disabled={viewMode} multiline={true} help_text={""} label_text={"Part number"} value={request.part_number} onTextChange={(text: string) => { onUpdateTextFields("part_number", text) }} type="text" width={95} />
            </div>
            <div className="w-full sm:w-full md:w-5/12">
                <Input icon={<FormatListNumbered />} disabled={viewMode} multiline={true} help_text={""} label_text={"Part name"} value={request.part_name} onTextChange={(text: string) => { onUpdateTextFields("part_name", text) }} type="text" width={95} />
            </div>
        </div>
        <div className="flex flex-wrap justify-center">
            <div className="w-full sm:w-full md:w-5/6">
                <Input icon={<Description />} disabled={viewMode} multiline={true} help_text={""} label_text={"Dash numbers"} value={request.dash_numbers} onTextChange={(text: string) => { onUpdateTextFields("dash_numbers", text) }} type="text" width={95} />
            </div>
        </div>

            <div className="flex flex-wrap justify-center"  >
                <div className="w-full sm:w-full md:w-5/12">
                    <Select selectedItem={selectedRating}
                            onSelectedItem={(e: any) => { onSelectedRating(e.target.value) }}
                            width={90}
                            widthPercentage={true}
                            filter_by_text="Rating"
                            optionsObject={ratingOptions}
                            disabled={viewMode}>

                    </Select>
                </div>
                <div className="w-full sm:w-full md:w-5/12" >
                </div>
            </div>
            <div className="flex flex-wrap justify-center"  >
                <div className="w-full sm:w-full md:w-5/12">
                    <SelectMultiple
                        disabled={viewMode || (!viewMode && selectedRating !== RatingEnum.C)}
                        customSelectedText={shopOptions
                            .filter(option => selectedShops.includes(option.id))
                            .map(option => option.name)
                            .join(', ')
                        }
                        optionsObject={shopOptions}
                        selectedItems={selectedShops}
                        widthPercentage={true}
                        width={90}
                        onSelectedItem={(e: any) => { onSelectedShop(e.target.value) }}
                        filter_by_text="Shops"
                    />
                </div>

                <div className="w-full sm:w-full md:w-5/12" >
                        <Input icon={<MenuBook />} disabled={viewMode} multiline={true} help_text={""} label_text={"CMM"} value={request.cmm_chapters} onTextChange={(text: string) => { onUpdateTextFields("cmm_chapters", text) }} type="text" width={90} />
                </div>
            </div>
            <div className="flex flex-wrap justify-center" >
                <div className="w-full sm:w-full md:w-5/12">
                    <Select
                        filter_by_text={`ATA Chapters ${request.ata_chapters}`}
                        options={ATAChapters.map((obj: ATAChapter) => obj.ata_chapter)}
                        onSelectedItem={(e: any) => {onAtaChapterSelected(e.target.value)}}
                        disabled={viewMode}
                        widthPercentage={true}
                        width={90}
                    />
                </div>
                <div className="w-full sm:w-full md:w-5/12">
                    <Input icon={<Title />}
                        disabled={true} 
                        multiline={true}
                        help_text={""}
                        label_text={"Class Type"}
                        value={request.class_type} 
                        onTextChange={(text: any) => {
                            onClassTypeChanged(text.target.value);
                        }}
                        type="text"
                        width={90} />
                </div>
            </div>
            {selectedRating !== RatingEnum.B && (
                <div className="flex flex-wrap justify-center">
                    <div className="w-full sm:w-full md:w-5/6">
                        <Input
                            icon={<Description />}
                            disabled={viewMode}
                            multiline={true}
                            help_text=""
                            label_text="Description of capability"
                            value={request.description}
                            onTextChange={(text: string) => onUpdateTextFields("description", text)}
                            type="text"
                            width={95}
                        />
                    </div>
                </div>
            )}

            {selectedRating === RatingEnum.B && (
                <div className="flex flex-wrap justify-center">
                    <div className="w-full sm:w-full md:w-5/6">
                        <Input
                            icon={<Description />}
                            disabled={viewMode}
                            multiline={true}
                            help_text=""
                            label_text="Component name"
                            value={request.component_name}
                            onTextChange={(text: string) => onUpdateTextFields("component_name", text)}
                            type="text"
                            width={95}
                        />
                    </div>
                    <div className="w-full sm:w-full md:w-5/6">
                        <Input
                            icon={<Description />}
                            disabled={viewMode}
                            multiline={true}
                            help_text=""
                            label_text="Task"
                            value={request.other_text}
                            onTextChange={(text: string) => onUpdateTextFields("other_text", text)}
                            type="text"
                            width={95}
                        />
                    </div>
                </div>

            )}
            
            {snackbarMessage && snackbarMessage.length > 0 && <Snackbar onSnackBarClose={() => setSnackbarMessage("")} open={true} message={snackbarMessage} severity='error' autoHide={true} horizontalPosition='right' />}
        </>
    )
}
export default TextFields;

